/* ==========================================================================
   Femme Aura — product page tabs

   Turns the product description plus the collapsible-tab blocks into a single
   tab strip (Details | Fit & Fabric | Shipping & Returns).

   Progressive by design: the markup stays exactly what Dawn rendered —
   a description block and a set of <details> accordions. This script only
   adds a tab bar in front of them and decides which one is open. If it never
   runs, the page falls back to a description followed by normal accordions,
   which is a perfectly usable product page rather than a broken one.

   The "Size guide" link is added here too, next to the Size legend, because
   that is where a shopper looks for it — it just opens the tab that holds
   the measurements.
   ========================================================================== */

(function () {
  'use strict';

  function build(scope) {
    var info = (scope || document).querySelector('.product__info-container');
    if (!info || info.dataset.faTabs === 'true') return;

    var panels = [];

    var desc = info.querySelector('.product__description');
    if (desc && desc.textContent.trim()) {
      panels.push({ label: 'Details', el: desc });
    }

    Array.prototype.forEach.call(info.querySelectorAll('.product__accordion'), function (acc) {
      var titleEl = acc.querySelector('.accordion__title') || acc.querySelector('summary');
      var label = titleEl ? titleEl.textContent.trim() : '';
      if (!label) return;
      panels.push({ label: label, el: acc, isAccordion: true });
    });

    // One panel is just a description; a tab strip would be noise.
    if (panels.length < 2) return;

    info.dataset.faTabs = 'true';
    info.classList.add('fa-has-tabs');

    var bar = document.createElement('div');
    bar.className = 'fa-tabs';
    bar.setAttribute('role', 'tablist');

    var buttons = [];

    panels.forEach(function (panel, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fa-tab';
      btn.textContent = panel.label;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', 'false');
      btn.addEventListener('click', function () {
        activate(i);
      });
      btn.addEventListener('keydown', function (e) {
        var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (next === null) return;
        e.preventDefault();
        var target = (next + panels.length) % panels.length;
        activate(target);
        buttons[target].focus();
      });
      buttons.push(btn);
      bar.appendChild(btn);

      panel.el.classList.add('fa-tab-panel');
      // An open <details> renders its content; the summary is hidden in CSS.
      if (panel.isAccordion) panel.el.open = true;
    });

    panels[0].el.parentNode.insertBefore(bar, panels[0].el);

    function activate(index) {
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.el.classList.toggle('fa-tab-active', on);
        buttons[i].classList.toggle('is-active', on);
        buttons[i].setAttribute('aria-selected', on ? 'true' : 'false');
        buttons[i].setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    activate(0);

    // "Size guide" beside the Size legend, pointing at whichever tab holds it
    var sizeTab = -1;
    panels.forEach(function (p, i) {
      if (/fabric|fit|size/i.test(p.label)) sizeTab = i;
    });
    if (sizeTab === -1) return;

    var legends = info.querySelectorAll('.product-form__input legend.form__label, .product-form__input .form__label');
    Array.prototype.forEach.call(legends, function (legend) {
      if (!/^\s*size/i.test(legend.textContent) || legend.querySelector('.fa-size-guide')) return;
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'fa-size-guide';
      link.textContent = 'Size Guide';
      link.addEventListener('click', function () {
        activate(sizeTab);
        buttons[sizeTab].focus();
        bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      legend.appendChild(link);
      legend.classList.add('fa-label-with-guide');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      build();
    });
  } else {
    build();
  }

  document.addEventListener('shopify:section:load', function (event) {
    build(event.target);
  });
})();
